export default __webpack_public_path__ + "images/svg-sprite/icon-star.svg";